import React, { useState } from 'react'
import { IssueEntity } from 'types/IssueEntity'
import { getShareNameAtPublicationHint } from './issueShareNameHint'
import InfoBlock from '../components/InfoBlock'
import { FactsTable, FactsTableRow } from '../components/FactsTable'
import Typography from '@mui/material/Typography'
import AdvisorList from './AdvisorList'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

type IssueInfoComponent = React.FC<{
    issue: IssueEntity
}>

export const IssueInfo: IssueInfoComponent = ({ issue }) => {
    const [isOpen, setIsOpen] = useState(false)
    const xxlScreenOrBigger = useMediaQuery('(min-width:1900px)')

    if (!issue) {
        return <InfoBlock title='Info' loadingElement={true} />
    }

    const shareNameHint = getShareNameAtPublicationHint(issue)
    const showExternalBlock = Boolean(shareNameHint || issue.externalComment)

    return (
        <InfoBlock title='Information'>
            <FactsTable>
                <FactsTableRow label='Lista'>
                    <Typography>{issue.marketplaceName}</Typography>
                </FactsTableRow>
                <FactsTableRow label='Finansiella rådgivare'>
                    {issue.noFinancialAdvisor ? (
                        '-'
                    ) : (
                        <AdvisorList advisors={issue.advisors} type='financial_advisor' />
                    )}
                </FactsTableRow>
                <FactsTableRow label='Legala rådgivare'>
                    {issue.noLegalAdvisor ? '-' : <AdvisorList advisors={issue.advisors} type='legal_advisor' />}
                </FactsTableRow>
                <FactsTableRow label='Emissionsinstitut'>
                    {issue.noIssuingAgent ? '-' : <AdvisorList advisors={issue.advisors} type='issuing_agent' />}
                </FactsTableRow>
            </FactsTable>
            {showExternalBlock ? (
                <>
                    <Divider />
                    {shareNameHint ? (
                        <Typography
                            variant='body1'
                            component='p'
                            sx={{
                                fontStyle: 'italic',
                                whiteSpace: 'pre-line',
                                px: 4,
                                pt: 4,
                            }}
                        >
                            {shareNameHint}
                        </Typography>
                    ) : null}
                    {issue.externalComment ? (
                        (issue.externalComment.length > 210 && !xxlScreenOrBigger) ||
                        (xxlScreenOrBigger && issue.externalComment.length > 400) ? (
                            <Stack
                                sx={{
                                    p: 4,
                                    pt: shareNameHint ? 2 : 4,
                                    pb: 0,
                                }}
                            >
                                <span style={{ whiteSpace: 'pre-line' }}>
                                    {isOpen
                                        ? issue.externalComment
                                        : `${issue.externalComment.slice(0, xxlScreenOrBigger ? 360 : 170)}...`}
                                </span>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Button
                                        variant='text'
                                        onClick={() => setIsOpen((prev) => !prev)}
                                        sx={{
                                            '&:hover': {
                                                //you want this to be the same as the backgroundColor above
                                                backgroundColor: '#FFF',
                                            },
                                        }}
                                    >
                                        {isOpen ? 'Visa mindre' : 'Visa mer'}
                                    </Button>
                                </Box>
                            </Stack>
                        ) : (
                            <Box
                                sx={{
                                    p: 4,
                                    pt: shareNameHint ? 2 : 4,
                                    pb: 0,
                                }}
                            >
                                <span style={{ whiteSpace: 'pre-line' }}>{issue.externalComment}</span>
                            </Box>
                        )
                    ) : null}
                </>
            ) : null}
        </InfoBlock>
    )
}
